"use client"

import ProductLabelSkeleton from "@/components/common/ProductLabel/index.skeleton"
import { useAppSelector } from "@/hooks/redux"
import { Col, Row, Skeleton } from "antd"

const ProductQuantitySkeleton = () => {
  const quantitySetting = useAppSelector(state => state.store.store_setting.data.quantity)
  
  return (
    <>
      <Row>
        <ProductLabelSkeleton />
      </Row>
      <Row>
        <Col span={24}>
          <Skeleton.Input style={{ height: `calc(5rem + ${quantitySetting.border_width}px)` }} styles={{ root: { width: '100%' }, content: { width: '100%' } }} size='large' />
        </Col>
      </Row>
    </>
  )
}

export default ProductQuantitySkeleton